import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad2CBlue2BRed = () => <CrossRoad coords="1148.000000, 688.000000"/>;
export default CrossRoad2CBlue2BRed;
